import React from 'react'
import './footer.css'
import Menu from '../nav/Menu'

const Footer = () => {
  return (
    <footer>
      <Menu />
      <div className="footer__copyright">
        <small>&copy; 2025 Julio Vargas</small>
      </div>

    </footer>
  )
}

export default Footer